import { render } from "./ContactMeComponent.vue?vue&type=template&id=13b7abaa&scoped=true"
const script = {}

import "./ContactMeComponent.vue?vue&type=style&index=0&id=13b7abaa&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b7abaa"]])

export default __exports__